var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getConfig } from "@jti/fe-common";
import { BrowserStorage } from "../../utils/BrowserStorage";
import { Rest } from "../Rest";
export class AemPDPMappingApiImpl extends Rest {
    constructor(servletUrl = "") {
        super("");
        this.isMappingLoaded = false;
        this.isInProgress = false;
        this.pendingPromise = null;
        this.name = "AemPDPMappingApiImpl";
        this.servletUrl = servletUrl;
        this.storageKey = this.getStorageKey();
        this.storage = new BrowserStorage(window.sessionStorage);
        this.mapping = this.storage.get(this.storageKey, []);
    }
    static init() {
        var _a;
        if (!((_a = window === null || window === void 0 ? void 0 : window.apiInstances) === null || _a === void 0 ? void 0 : _a.aemPDPMapping)) {
            const aemPDPMappingApiInstance = new AemPDPMappingApiImpl(getConfig().PDP_MAPPING_URL);
            window.apiInstances = Object.assign(Object.assign({}, window === null || window === void 0 ? void 0 : window.apiInstances), { aemPDPMapping: aemPDPMappingApiInstance });
        }
        return window.apiInstances.aemPDPMapping;
    }
    getMapping() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.mapping.length || this.isMappingLoaded) {
                return this.mapping;
            }
            if (this.isInProgress) {
                yield this.pendingPromise;
                return this.mapping;
            }
            try {
                this.isInProgress = true;
                this.pendingPromise = this.request(this.servletUrl, {}, false, false);
                const result = yield this.pendingPromise;
                const data = result.data;
                this.mapping = data;
                this.storage.set(this.storageKey, data);
                this.isMappingLoaded = true;
                return data;
            }
            catch (e) {
                this.pendingPromise = null;
                console.warn("Error fetching PDP mapping", e);
            }
            finally {
                this.isInProgress = false;
            }
            return [];
        });
    }
    getLinkBySku(sku) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.mapping.length && !this.isMappingLoaded) {
                yield this.getMapping();
            }
            const pdpRecord = this.mapping.find((mapping) => {
                return mapping.sku === sku;
            });
            if (!pdpRecord) {
                console.log(`No PDP mapping found for SKU: ${sku}`);
            }
            return (pdpRecord === null || pdpRecord === void 0 ? void 0 : pdpRecord.pdpLink) || "";
        });
    }
    getStorageKey() {
        const mappingName = this.servletUrl.replace(/\/|\.json/g, "");
        return `cache-${mappingName}`;
    }
}
//# sourceMappingURL=AemPDPMapping.js.map